<template>
  <VDialog v-model="dialogModel" width="600">
    <template v-slot:activator="{on,attrs}">
      <VBtn
        class="int-dis-btn int-btn"
        v-bind="attrs"
        v-on="on"
        color="white"
        elevation="0"
        outlined
      >
        {{ $t('disable') }}
      </VBtn>
    </template>
    <VCard>
      <VCardTitle>{{ $t('title') }}</VCardTitle>
      <VCardText>{{ $t('text') }}</VCardText>
      <VCardText class="align-center">
        <VBtn @click="disable" color="red">
          {{ $t('disable') }}
        </VBtn>
        <VBtn class="ml-3" @click="dialogController.closeDialog()">
          {{ $t('cancel') }}
        </VBtn>
      </VCardText>
    </VCard>
  </VDialog>
</template>
<script>
import useDialog from '@/compositions/useDialog';
import Integration from '@/orm/models/Integration/Integration';
import useValidation from '@/compositions/useValidation';
import {
  toRefs,
} from '@vue/composition-api';
import User from '@/orm/models/User/User';

export default {
  name: 'IntegrationsListItemDisable',
  props: {
    integration: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { dialogController, dialogModel } = useDialog();
    const { withValidationHandling, hasErrors } = useValidation();
    const { integration } = toRefs(props);

    async function disable() {
      await withValidationHandling(async () => {
        await Integration.api().disable(User.getAuthUser().company.id, integration.value.id);
      });
      if (!hasErrors.value) {
        await Integration.update({
          where: integration.value.$id,
          data: {
            connected: false,
            integrationEmail: null,
          },
        });
      }
      dialogController.closeDialog();
      emit('disable', true);
    }

    return {
      dialogModel,
      dialogController,
      disable,
    };
  },
};
</script>

<style lang="scss" scoped>
.int-dis-btn.v-btn {
  color: #EB5757 !important;
  border: 1px solid rgba(0, 0, 0, 0.1);
  border-radius: 0.25rem;
}
.int-btn {
  width: 120px;
}

</style>

<i18n lang="yml" locale="en">
disable: Disable
</i18n>
<i18n lang="yml" locale="ru">
disable: Отключить
title: Отключение интеграции с Rabota.ru
text: 'После отключения интеграции импорт новых кандидатов с Rabota.ru прекратится.
Все уже импортированные кандидаты останутся в Huntica.'
cancel: Отмена
</i18n>
